export const CHAT_IMAGE_DISPLAY = {
  bubble: { width: 64, height: 64 },
  header: { width: 150, height: 20 },
  avatar: { width: 32, height: 32 },
} as const;

export const CHAT_IMAGE_UPLOAD_LIMITS = {
  bubble: {
    maxFileSize: 1024 * 1024,
    recommendedSize: '64×64 px',
    recommendedWidth: CHAT_IMAGE_DISPLAY.bubble.width,
    recommendedHeight: CHAT_IMAGE_DISPLAY.bubble.height,
  },
  header: {
    maxFileSize: 1024 * 1024,
    recommendedSize: 'up to 150×20 px',
    recommendedWidth: CHAT_IMAGE_DISPLAY.header.width,
    recommendedHeight: CHAT_IMAGE_DISPLAY.header.height,
  },
  avatar: {
    maxFileSize: 512 * 1024,
    recommendedSize: '32×32 px',
    recommendedWidth: CHAT_IMAGE_DISPLAY.avatar.width,
    recommendedHeight: CHAT_IMAGE_DISPLAY.avatar.height,
  },
} as const;

export type ChatImageUploadVariant = keyof typeof CHAT_IMAGE_UPLOAD_LIMITS;
